'use client';

import { useContext, useEffect } from 'react';
import { Survey } from '@/app_components/Article/ArticleHeader/components/Survey/Survey';
import { UserContext } from '@/app_lib/providers/UserProvider';

interface SurveyGateProps {
  showSurvey: boolean;
  audienceType: string;
}

/**
 * Client-only wrapper that reads Piano cookies and conditionally renders the Survey.
 * Keeps cookie-dependent logic out of the server-rendered ArticleHeaderDefault.
 */
export const SurveyGate = ({ showSurvey, audienceType }: SurveyGateProps) => {
  const { userAccess } = useContext(UserContext);

  if (!(showSurvey && userAccess)) {
    return null;
  }

  const hasAccess = userAccess.hasAccess;
  const isAuth = userAccess.pianoUserToken;

  const shouldShow =
    audienceType === 'default' ||
    audienceType === '' ||
    (audienceType === 'subscribed' && hasAccess) ||
    (audienceType === 'not_subscribed' && isAuth && !hasAccess) ||
    (audienceType === 'guest' && !isAuth);

  return <div className='w-full h-24 mb-8'>{shouldShow ? <Survey /> : <span />}</div>;
};
